<bfx-close></bfx-close>
<div class="auth__login__panel" nativeDesktopClass="desktop">
  <div fxLayout="row" fxLayoutAlign="space-around start" class="auth__login__panel__header">
    <div fxFlex="50" class="auth__login__panel__header-logo">
      <bfx-logo-svg></bfx-logo-svg>
    </div>
    <div fxFlex="50" class="auth__login__panel__header-title">{{ frameTag }}</div>
  </div>
  <div class="auth__login__panel__body">
    <div class="logOutContent">
      <div fxFlex fxLayout="row" fxLayoutAlign="space-around center">
        <div fxFlex="27" class="logOutIconSpacing">
          <span class="icon icon-bfx_failed bfx-icon-xlg"></span>
        </div>
        <div class="logOutTextSpacing" fxFlex="73" fxLayout="column" fxLayoutAlign="start start">
          <div fxFlex="40" class="title">You have been signed-out!</div>
          <div fxFlex="50" class="text" *ngIf="!isNativeDesktop">
            In order to access OMS you need to
            <a role="button" (click)="reroute()">Sign-in again</a>.<br />
          </div>
          <div fxFlex="50" class="text" *ngIf="isNativeDesktop">
            Please wait for application to exit.
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="auth__login__panel__footer">
    <p class="copyright">&copy; BarracudaFX</p>
  </div>
</div>
